import { z } from 'zod';
import { exportConfirmationSchema } from './batches';

/** SPEC §7 — CSV export. */

export const EXPORT_ENGLISH_URL_HEADER = 'english_audio_url';
export const EXPORT_ARABIC_URL_HEADER = 'arabic_audio_url';

/**
 * GET /api/batches/:id/export/confirmation — the numbers behind
 * "Export — 28 of 40 rows fully approved, 3 stale. Continue?".
 * (The same object is embedded in GET /api/batches/:id.)
 */
export const exportConfirmationResponseSchema = z.object({
  confirmation: exportConfirmationSchema,
});
export type ExportConfirmationResponse = z.infer<typeof exportConfirmationResponseSchema>;

/**
 * POST /api/batches/:id/export — always allowed; responds with the file itself
 * (`text/csv; charset=utf-8`, `Content-Disposition: attachment`).
 * UTF-8 **with BOM**, CRLF, RFC-4180 quoting.
 */
export const exportRequestSchema = z.object({
  /** Reserved: exporting only a subset is not in v1, but the field keeps the contract stable. */
  rowIds: z.array(z.string()).optional(),
});
export type ExportRequest = z.infer<typeof exportRequestSchema>;

/** Metadata mirrored into response headers (`X-Tekvoice-*`) for the client toast. */
export const exportResultMetaSchema = z.object({
  filename: z.string(),
  rowCount: z.number().int().min(0),
  approvedRowCount: z.number().int().min(0),
  staleRowCount: z.number().int().min(0),
  byteLength: z.number().int().min(0),
});
export type ExportResultMeta = z.infer<typeof exportResultMetaSchema>;
